import { render, staticRenderFns } from "./app-confirm.vue?vue&type=template&id=47879e04"
import script from "./app-confirm.vue?vue&type=script&lang=js"
export * from "./app-confirm.vue?vue&type=script&lang=js"
import style0 from "./app-confirm.vue?vue&type=style&index=0&id=47879e04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports